import { useRef } from "react";

import axios from "axios";
import { MUTATION_KEYS } from "library/shared";
import { IChatbotMessage } from "library/types";
import { useMutation } from "react-query";
import api from "service/api";

import useNotificationHandler from "hooks/useNotificationHandler";

type Params = {
  payload: IChatbotMessage;
  signal?: AbortSignal;
};

const sendMsgToChatbot = async ({ payload, signal }: Params) => {
  const response = await api.post(
    `/ChatBot`,
    {
      ...payload,
    },
    { signal }
  );

  return response.data as string;
};

export function useSendMsgToChatbot() {
  const { handleAddAxiosErrorNotification } = useNotificationHandler();
  const abortControllerRef = useRef<AbortController | null>(null);

  const mutation = useMutation(
    (params: Omit<Params, "signal">) => {
      abortControllerRef.current?.abort();
      const controller = new AbortController();
      abortControllerRef.current = controller;
      return sendMsgToChatbot({ ...params, signal: controller.signal });
    },
    {
      mutationKey: MUTATION_KEYS.sendMessageToChatbot,
      onError: (error) => {
        if (axios.isCancel(error)) {
          return;
        }
        handleAddAxiosErrorNotification(error);
      },
    }
  );

  const cancel = () => {
    abortControllerRef.current?.abort();
    abortControllerRef.current = null;
  };

  return { ...mutation, cancel };
}
